<template>
  <div>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input
            v-model="query.key"
            placeholder="请输入关键词"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick()">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>图片列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column label="名称" prop="name" width="330" fixed>
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="themeColor"
            label="图片"
            align="center"
            width="320"
          >
            <template slot-scope="scope">
              <el-image
                :src="domain + scope.row.imageURL"
                style="height: 80px"
                fit="contain"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="product.name"
            label="所属产品"
            align="center"
            width="260"
          >
            <template slot-scope="scope">
              <a
                :href="
                  domainFront +
                  '/product' +
                  scope.row.product.productType.productTypeParent.id +
                  '/' +
                  scope.row.product.typeID +
                  '/' +
                  scope.row.id +
                  '.html'
                "
                target="_blank"
                class="el-link el-link--default is-underline"
              >
                <span>{{ scope.row.name }}</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            prop="seq"
            label="排序"
            sortable
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="editor.realName"
            label="编辑人"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="editTime"
            label="编辑时间"
            sortable
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="230"
          >
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑图片' : '添加图片'"
      :visible.sync="dialogVisible"
      @opened="dialogOpended()"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入图片名称' }]"
        >
          <el-input
            v-model.trim="form.name"
            placeholder="请输入图片名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="imageURL">
          <div id="uploadBtn1" class="uploader uploader-warning"></div>
          <img
            id="imgTarget1"
            :src="form.imageURL"
            style="width: 50px; position: relative; left: 10px; top: 20px"
          />
        </el-form-item>

        <el-form-item
          label="排序数字"
          prop="seq"
          :rules="[{ type: 'number', message: '请填写数字' }]"
        >
          <el-input
            v-model.number="form.seq"
            placeholder="请输入排序数字"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false, resetForm('form')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  props: {
    deliverProID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      domain: url.getDomain(),
      domainFront: url.getDomainFront(),
    };
  },
  methods: {
    dialogOpended() {
      var _this = this;
      if ($("#uploadBtn1 input").length == 0) {
        $("#uploadBtn1").uploader({
          url: "ws://" + url.getHost() + "/upload/images",
          fileExts: "jpg;png;gif;jpeg",
          text: "上传图片",
          handleType: "0",
          subfolder: "uniimage",
          onSuccess: function (data) {
            //添加到列表,每个图片上传成功都会触发
            var src = _this.domain + data.relativeName;
            $("#imgTarget1").attr("src", src);
            _this.form.imageURL = data.relativeName;
          },
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.productID = _this.deliverProID;
      var link = url.getProductImage("getlist");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getProductImage("save");
      var info = this.form;
      info.productID = this.deliverProID;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.resetForm("form");
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //添加
    addClick: function () {
      this.dialogVisible = true;
      this.form = { seq: 999 };
    },
    //编辑
    editClick: function (row) {
      // this.form = Object.assign({}, row);
      this.dialogVisible = true;
      var id = row.id;
      var link = url.getProductImage("getmodel");
      $.get(link, { id: id }, (res) => {
        this.form = res;
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getProductImage("delete"); //获取请求地址
      var id = row.id; //获取对象id
      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //窗口关闭事件
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("form");
          done();
        })
        .catch((_) => {});
    },
    //重置表单/重置校验
    resetForm(formName) {
      //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs[formName].resetFields(); //prop：在使用 validate、resetFields 方法的情况下，该属性是必填的
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
  },
  watch: {
    // 监听传过来的值的变化，根据变量重新刷新列表
    deliverProID: {
      handler(newValue, oldValue) {
        this.deliverProID = newValue; //赋值
        this.getList(); // 刷新图片列表
      },
      // deep:true,// 深度监听父组件传过来对象变化
      // immediate:true, //是否在页面初始化时就启用，true：是
    },
  },
};
</script>